export type CfVerificationRetry = 'none' | 'scheduled' | 'running' | 'errored';

// Right after a nameserver change the old host can still be answering for a few
// minutes, so a first failed verification is not yet a verdict.
export const VERIFICATION_RETRY_DELAY_MS = 60_000;

// The server's verification poll alone runs for up to a minute, so the notice
// has to outlast it or the final verdict shows while the check is still running.
export const VERIFICATION_RETRY_NOTICE_MS = 90_000;


export const isRetryPending = (retry: CfVerificationRetry): boolean => retry === 'scheduled' || retry === 'running';
